import React from "react";
import AddIdeaButton from "./buttons/AddIdeaButton";
import DownloadReportButton from "./buttons/DownloadReportButton";
import ViewKPIImpactButton from "./buttons/ViewKPIImpactButton";
import { Paper, Stack, Typography } from "@mui/material";

export default function DashboardTopBar() {
  return (
    <Paper elevation={0} sx={{ p: 1, mb: 1 }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="h5" fontWeight="bold" sx={{ color: "#4F46E5" }}>
          Continuous Improvement Dashboard
        </Typography>
        <Stack direction="row" spacing={1}>
          <AddIdeaButton />
          <DownloadReportButton />
          <ViewKPIImpactButton />
        </Stack>
      </Stack>
    </Paper>
  );
}
